<template>
  <app-modal ref="modal" close-on-backdrop-click>
    <div class="modal">
      <header class="modal__header modal-header">
        <span class="modal-header__logo icon-paypal-logo"></span>
        <button v-modal-submit class="modal-header__close-button">
          <span class="icon-cross-white"></span>
        </button>
        <h3 class="modal-header__title u-typography-helvetica u-text u-text--l">
          {{ $t('paypal.label.buyNowPayLaterTitle') }}
        </h3>
      </header>

      <vue-perfect-scrollbar class="modal__content">
        <pay-pal-pay-later-info
          :country="country"
          :payment-amount="paymentAmount"
          :payment-part="paymentPart"
          :placement="placement"
        />
      </vue-perfect-scrollbar>
    </div>
  </app-modal>
</template>

<script>
import AppModal from '@/components/common/AppModal.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import PayPalPayLaterInfo from '@/components/shipping/payment-method/PayPalPayLaterInfo.vue';

export default {
  name: 'PayPalPayLaterInfoModal',
  components: { PayPalPayLaterInfo, VuePerfectScrollbar, AppModal },
  props: {
    country: {
      type: String,
      default: ''
    },
    paymentAmount: {
      type: String,
      default: ''
    },
    paymentPart: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: ''
    }
  },
  methods: {
    open() {
      return this.$refs.modal.open();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/icon';
@import '../../../assets/scss/colors.scss';

.modal {
  position: relative;
  width: 90vw;
  max-width: 600px;
  max-height: 600px;
  height: 90vh;
  padding-top: 180px;
  padding-bottom: 30px;
  background-color: var(--u-color-white);

  &__content {
    height: fit-content;
    max-height: 95%;
    padding: 0 24px;
  }

  &__header {
    position: absolute;
    top: 0;
    height: 143px;
    width: 100%;
    margin-bottom: 24px;
  }
}

.modal-header {
  padding-top: 84px;
  padding-left: 48px;
  background-color: #009cde;
  border-radius: 0px 0px 0px 44px;
  z-index: 20;

  &__title {
    color: var(--u-color-white);
  }

  &__logo,
  &__close-button {
    position: absolute;
    background-color: transparent;
    border: none;
  }

  &__close-button {
    top: 29px;
    right: 25px;
    cursor: pointer;
  }

  &__logo {
    top: 24px;
    left: 48px;
  }
}

@media (min-width: 960px) {
  .modal {
    padding-top: 200px;

    &__header {
      height: 167px;
      padding-top: 96px;
      margin-bottom: 32px;
    }

    &__content {
      padding: 0 50px;
    }
  }
}
</style>
